import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <section className="relative flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 pt-24 text-center">
      <h1 className="pointer-events-none absolute bottom-0 select-none font-heading text-[10rem] font-black leading-none text-background-200 md:text-[14rem]">
        404
      </h1>
      <div className="relative z-10">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-600">
          <i className="ri-compass-3-line text-3xl" />
        </span>
        <h2 className="mt-6 font-heading text-3xl text-foreground-950">페이지를 찾을 수 없습니다</h2>
        <p className="mt-3 text-sm text-foreground-500">{location.pathname}</p>
        <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          주소가 변경되었거나 삭제된 페이지입니다. 아래 버튼을 통해 원하시는 페이지로 이동해 주세요.
        </p>
        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line" /> 메인으로 가기
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-6 py-3.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            <i className="ri-customer-service-2-line" /> 고객문의
          </Link>
        </div>
      </div>
    </section>
  );
}